<script>
import CartItem from '@phoenix/mixins/components/light-checkout/order/CartItem';

export default {
  mixins: [CartItem],
};
</script>

<template>
  <cart-item-template
    :reservation-number="item.modelReference"
    :image="item.image"
    :title="item.name"
    :reference="item.modelReference"
    :model="item.modelReference"
    :sap-reference="item.sapReference"
    :description="item.ppSubtitle ?? item.description"
    :collection-name="item.collection"
  >
    <template #price>
      <product-price
        v-if="localizedPrice"
        v-bind="localizedPrice"
        :should-display-from-price="false"
        :price-on-demand="false"
      />
    </template>
  </cart-item-template>
</template>
